import React, { Component } from "react";
import ReactDOM from "react-dom";
import LoadingOverlay from "react-loading-overlay";

class SimpleLoadingOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      container: null,
    };
  }

  componentDidMount() {
    const app = document.getElementsByClassName("app");
    if (app.length > 0) {
      this.setState({
        container: app[0],
      });
    }
  }

  render() {
    const { active } = this.props;
    if (!active || !this.state.container) {
      return null;
    }

    return ReactDOM.createPortal(
      <LoadingOverlay
        styles={{
          wrapper: (base) => ({
            ...base,
            width: "100%",
            height: "100%",
            position: "absolute",
            zIndex: 1000,
          }),
        }}
        active={this.props.active}
        spinner
      />,
      this.state.container
    );
  }
}

export default SimpleLoadingOverlay;
